import { c as _c } from "react/compiler-runtime";
export const BlacksmithLogomarkSVG = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 96" fill="none"><title>Blacksmith</title><path fill="currentColor" d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};